export const RADIUSES = [
  20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300, 500, 800, 1000, 1500, 2000,
]
